//@ts-check

/**
 * @type {import('./types').json2xmlType}
 */
function json2xml(object) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      tab = _ref.tab,
      elementNameFn = _ref.elementNameFn,
      attributeNameFn = _ref.attributeNameFn,
      attributesKey = _ref.attributesKey;

  attributesKey = attributesKey || '@attributes';

  var toXml = function toXml(v, name, ind) {
    var xml = '';

    if (v instanceof Array) {
      for (var i = 0, n = v.length; i < n; i++) {
        xml += ind + toXml(v[i], name, ind + '\t') + '\n';
      }
    } else if (typeof v == 'object') {
      var hasChild = false;
      var elementName = typeof elementNameFn === 'function' ? elementNameFn(name) : name;
      xml += ind + '<' + elementName;

      for (var m in v) {
        if (m === attributesKey) {
          for (var attrKey in v[m]) {
            var attributeName = typeof attributeNameFn === 'function' ? attributeNameFn(attrKey) : attrKey;
            xml += ' ' + attributeName + '="' + escapeXml(v[m][attrKey].toString()) + '"';
          }
        } else {
          hasChild = true;
        }
      }

      xml += hasChild ? '>' : '/>';

      if (hasChild) {
        for (var m in v) {
          if (m == '#text') xml += v[m];else if (m == '#cdata') xml += '<![CDATA[' + v[m] + ']]>';else if (m !== attributesKey) xml += toXml(v[m], m, ind + '\t');
        }

        xml += (xml.charAt(xml.length - 1) == '\n' ? ind : '') + '</' + elementName + '>';
      }
    } else {
      var _elementName = typeof elementNameFn === 'function' ? elementNameFn(name) : name;

      xml += ind + '<' + _elementName + '>' + v.toString() + '</' + _elementName + '>';
    }

    return xml;
  };

  var xml = '';

  for (var key in object) {
    xml += toXml(object[key], key, '');
  }

  return tab ? xml.replace(/\t/g, tab) : xml.replace(/\t|\n/g, '');
}

function escapeXml(unsafe) {
  return unsafe.replace(/[<>&'"]/g, function (c) {
    switch (c) {
      case '<':
        return '&lt;';

      case '>':
        return '&gt;';

      case '&':
        return '&amp;';

      case "'":
        return '&apos;';

      case '"':
        return '&quot;';
    }
  });
}

export default json2xml;